import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import DefinitionListItemKey from "./DefinitionListItemKey";
import DefinitionListItemValue from "./DefinitionListItemValue";

function getColor(color) {
  switch (color) {
    case "main":
      return "em-c-definition-list__item--main";
    case "accent":
      return "em-c-definition-list__item--accent";
    case "default":
    default:
      return "";
  }
}

const DefinitionListItem = props => {
  const { className, color, children, ...other } = props;

  return (
    <li
      className={clsx("em-c-definition-list__item", getColor(color), className)}
      {...other}
    >
      {children}
    </li>
  );
};

DefinitionListItem.Key = DefinitionListItemKey;
DefinitionListItem.Value = DefinitionListItemValue;

DefinitionListItem.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** Theme color of the list items */
  color: PropTypes.oneOf(["default", "main", "accent"]),
  /** React component children */
  children: PropTypes.node
};

DefinitionListItem.defaultProps = {
  className: "",
  color: "default",
  children: null
};

export default DefinitionListItem;
